namespace advisorop.domains {
    "use strict";

    export interface ICalendar {
        idString?: string;

        name?: string;

        owner?: string;

        isDefault?: boolean;

        color?: string;

        calendarType?: domains.CalendarType;

        include?: boolean;
    }
}